module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "page_8"
    }
  }, [_c('a', {
    attrs: {
      "id": "lev03"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0008-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Embroidery is a very rewarding art. It will give you years of enjoyment, but like any hobby or craft, it takes practice and patience. Start with the proper tools and materials and get to know their uses.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentbull"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/bull.jpg"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Fabrics.")]), _vm._v(" The fabric acts as the background for your needlework. It should enhance the needlework, not overshadow it. Always add an extra 2″ to the fabric measurement to aid handling and stretching of the fabric prior to stitching. Ask yourself these questions when choosing a fabric:")]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_vm._v("a. Is the fabric appropriate for the subject matter?")]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_vm._v("b. How much wear and tear will it receive?")]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_vm._v("c. Will the threads, yarn, or ribbon work up properly on the fabric selected?")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("1. "), _c('em', [_vm._v("Plush, Velvets, and Wools")]), _vm._v("—work these fabrics with a large-eyed needle. Use stitches that will sit up on the fabric, or the stitches may get lost in the texture of the fabric.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("2. "), _c('em', [_vm._v("Cottons, Polyesters, Linens, and Shantungs")]), _vm._v("—these are medium-weight fabrics and can support many types of embroidery.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("3. "), _c('em', [_vm._v("Moiré, Taffeta, Shot Cloths, and Satins")]), _vm._v("—these fabrics take on an old-fashioned Victorian look that’s good for fancy work associated with weddings or formal accessories.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("4. "), _c('em', [_vm._v("Lightweight Silks, Organzas, and Batistes")]), _vm._v("—treat these fabrics with care as they are very delicate. They may need a bottom layer to stabilize them. Keep the thread and ribbon ends well concealed, or they may show through such delicate fabrics.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("5. "), _c('em', [_vm._v("Knits, Loosely Woven Fabrics")]), _vm._v("—some of the loose weaves may need a stable fabric on the back to hold the stitches in place.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("6. "), _c('em', [_vm._v("Leather and Ultrasuede")]), _vm._v("®—have the stiletto ready since every hole must be punched because of the thickness of the material. This is a tedious process, but worth the effort.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v("7. "), _c('em', [_vm._v("Canvas for Needlepoint or Cross Stitch")]), _vm._v("—these specialty fabrics come in different fibers (such as cotton or linen) and the holes are spaced according to size (number of threads to the inch).")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0009-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentbull"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/bull.jpg"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Needles.")]), _vm._v(" Always have a variety of needles on hand. Be sure to use the proper needle as it will make your work much easier. The higher the number of the needle, the smaller the size and finer the needle.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("1. "), _c('em', [_vm._v("Beading")]), _vm._v("—a very fine needle with a tiny eye. It is strictly for beading. Traditionally, they are quite long for ease in loading the needle with beads. There are also sharps beading needles (shorter and excellent for picking up one bead at a time; I recommend a sharps #10).")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("2. "), _c('em', [_vm._v("Betweens")]), _vm._v("—a short needle with a small round eye. Use for quilting and fine hand sewing. Common sizes are 5 to 12.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("3. "), _c('em', [_vm._v("Crewel (Embroidery)")]), _vm._v("—a sharp needle with a long, oval eye. Use for fine to medium surfaces. Common sizes are 1 to 10.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("4. "), _c('em', [_vm._v("Chenille")]), _vm._v("—a long-eyed needle with a sharp point. Use for working heavy threads, fabrics, and silk ribbon embroidery. Common sizes are 18 to 24; keep a good stock of all these sizes.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("5. "), _c('em', [_vm._v("Darner")]), _vm._v("—a long, strong needle with a large eye. Good for assembly work, wool darning, and working with heavy threads and fabrics. Keep an assortment of sizes 14 to 18 on hand.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("6. "), _c('em', [_vm._v("Millinery (Straw Needle)")]), _vm._v("—a long, narrow needle, the same thickness from end to end, with a small, round eye. Excellent for making French knots.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("7. "), _c('em', [_vm._v("Sharps")]), _vm._v("—a fine, strong, round-eyed needle that’s rather short. Excellent for fine embroidery and hand sewing. Common sizes are 10, 11, and 12.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("8. "), _c('em', [_vm._v("Tapestry")]), _vm._v("—a large oval-eyed needle with a rounded point. Use for working pulled and drawn work and silk ribbon embroidery. Comes in sizes 13 to 26.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0009-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentbull"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/bull.jpg"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Threads.")]), _vm._v(" The choice of thread is always governed by your choice of fabric and the project in mind. Learn to experiment with different threads and yarns to find which types work best with different types of fabrics.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("1. "), _c('em', [_vm._v("Brazilian Embroidery Thread")]), _vm._v("—a rayon twisted embroidery thread with a good sheen. Use short lengths as it tends to knot up. Avoid kinks in the thread by first dampening a cloth with water, then drawing the thread over it before using.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("2. "), _c('em', [_vm._v("Cotton á Broder")]), _vm._v("—a single, highly-twisted thread with a shiny finish.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("3. "), _c('em', [_vm._v("Crewel Yarns")]), _vm._v("—very fine three-stranded wool. The strands can be separated and used singly for embroidery.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("4. "), _c('em', [_vm._v("Filo-Floss")]), _vm._v("—a soft, loosely twisted, six-stranded pure silk thread. It can be separated like cotton floss, then used singly or in varying multiple strands as desired.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("5. "), _c('em', [_vm._v("Linen Thread")]), _vm._v("—a highly twisted, single thread that’s very strong and has a slight sheen.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("6. "), _c('em', [_vm._v("Marlett")]), _vm._v("—a very shiny, viscose thread. Comes in loose strands which can be separated for finer work.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("7. "), _c('em', [_vm._v("Metallics")]), _vm._v("—any thread with glitter and shine is referred to as a metallic. Pure gold and silver threads are tarnishable and need careful handling, but many imitations are available. Keep a good variety on hand for couching and weaving techniques. I prefer machine embroidery metallics because they are smoother and pass easier through fabric.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("8. "), _c('em', [_vm._v("Natesh")]), _vm._v("®—a rayon thread with a wonderful sheen. Double it for Victorian crazy quilt stitching. It’s also good for use in machine embroidery.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("9. "), _c('em', [_vm._v("Perle Cotton")]), _vm._v("—a single thread with a sharply defined twist and low lustre; available in plain and random-dyed colors. Often used for crochet, perle cotton is wonderful for creating texture in embroidery. Available in sizes 3, 5, and 8 (the thinnest).")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("10. "), _c('em', [_vm._v("Persian Wool")]), _vm._v("—a three-stranded wool, thicker than crewel but thinner than "), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _vm._v("tapestry, that can be easily separated. Use for textural work in pictorial crazy quilting.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("11. "), _c('em', [_vm._v("Silk Buttonhole Twist")]), _vm._v("—an exquisite thread that will surely spoil you! The silk takes on a special sheen that stands up to lots of wear—plus it feeds through the fabric so easily. I use it exclusively for Victorian stitchery. One strand is equivalent to three strands of embroidery floss. For a two hundred plus color range, try the variety of Kanagawa® silk threads.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("12. "), _c('em', [_vm._v("Silk Ribbon")]), _vm._v("—once you’ve tried silk ribbon, you will never accept a substitute. The bias silk ribbon retains its color and comes in a large range of colors. It can be used in a variety of ways, including embroidery, punch needle, and covering seams. It creates wonderful texture and is very pliable and soft.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("13. "), _c('em', [_vm._v("Silk Sewing Thread")]), _vm._v("—a single strand of very fine thread that’s used for fine heirloom sewing. Try combining this thread with other threads.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("14. "), _c('em', [_vm._v("Soi d’ Algere")]), _vm._v("—seven-stranded silk thread that can be separated or used “as is.\"")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("15. "), _c('em', [_vm._v("Stranded Embroidery Floss")]), _vm._v("—a six-stranded cotton thread that easily separates to use the strands one at a time or in multiples.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("16. "), _c('em', [_vm._v("Tapestry Wool")]), _vm._v("—a thick, bulky yarn, traditionally used for needlepoint. It can be used in punch needle or embroidery. Try combining it with metallics for variety.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("17. "), _c('em', [_vm._v("Ver a Soi")]), _vm._v("—twisted silk thread similar to buttonhole twist.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0011-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentbull"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/bull.jpg"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Stitching Instructions.")]), _vm._v(" Working from the back of the fabric, insert the threaded needle into the fabric 2″-3″ from the starting point of the first stitch, then work a few running stitches to secure the thread end. The running stitches can be covered as you complete the embroidery stitches (securing the thread end). The running stitches "), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _vm._v("also can be taken out after the design is stitched. Work the thread end back into the needle, then work the needle through the backs of the completed stitches.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0010-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentbull"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/bull.jpg"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Silk Ribbon Embroidery.")]), _vm._v(" The secret to good silk ribbon embroidery is to keep the stitches loose and even. Silk ribbon embroidery is dimensional and fast. Here are a few tips to make your stitching easy and successful:")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("1. "), _c('em', [_vm._v("Threading Up the Ribbon")]), _vm._v("—remember, silk ribbon is delicate and will fray on the edges. Use a short length (12″ to 16″).")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("2. "), _c('em', [_vm._v("Needle Eye Lock")]), _vm._v("—thread the ribbon through the eye of the needle. Pierce one end of the ribbon (directly in the center and ¼″ from the end) with the point of the needle. Pull the long end of the ribbon and lock it into the eye of the needle.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0012-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("3. "), _c('em', [_vm._v("Soft Knot")]), _vm._v("—make the needle eye lock. Grasp the end of the ribbon then form a circle with the end of the ribbon and the point of the needle (A). Pierce the end of the ribbon with a short running stitch (B). Pull the needle and ribbon through the running stitch to form a soft knot.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0012-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("4. "), _c('em', [_vm._v("Ribbon Manipulation")]), _vm._v("—learn to use the ribbon properly. If it is pulled too tight or it twists too much, it will just look like a heavy thread.")]), _vm._v(" "), _c('p', {
    staticClass: "number1"
  }, [_vm._v("Keep the ribbon length short, as it is easier to manipulate. Use your free thumb to hold the ribbon flat against the fabric. Most stitches depend on the ribbon being flat. Keep the thumb in place while you stitch and tighten the "), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _vm._v("ribbon over the thumb. This will remove any twists. A large needle or a knitting stitch holder can be used instead of your thumb.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0012-04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("5. "), _c('em', [_vm._v("Adjusting the Ribbon")]), _vm._v("—sometimes the ribbon will fold up on itself as it passes through the fabric, and it has to be adjusted so the full width of the ribbon shows. Hold the ribbon flat under the free thumb and slide the needle under the ribbon, then gently slide the needle back and forth (from the thumb to the needle hole in the fabric).")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("6. "), _c('em', [_vm._v("Correct Needles")]), _vm._v("—above all, use a chenille needle when piercing through fabric; use a tapestry needle for wrapping or whipping. Remember the heavier the fabric, the larger the eye of the needle you should use for stitching.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0013-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0013-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentbull"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/bull.jpg"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Using the Punch Needle.")]), _vm._v(" Start out with a simple design and a medium-sized needle that will take about three strands of floss. Make sure the fabric is drum tight in the embroidery hoop or the stitches will not hold. Remember that since the design is punched from the back, it will face the opposite way on the front of the fabric. Make sure the design is facing in the proper direction!")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("1. Closely examine your needle. On the pointed end, one side is open and cut at an angle. On the other side is a small eye. The open side must always be facing in the direction in which you are stitching. The thread must be coming up at the top through the eye. Hold the needle much like a pencil. Relax your hand and do not hold too tight. Make sure the thread coming out the end of the handle is not obstructed.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0013-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _vm._v("2. Insert the needle into the fabric and push it all the way down until the stitch gauge stops it. Hold the needle at about a 70° angle. I like to use the angle of the cut side of the needle as a guide. Lift the needle back to the surface and drag it along to the next stitch—about "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/frac1-32.jpg"
    }
  }), _vm._v("″ (1mm) — and repeat. Think of it as punch, drag, punch, drag!")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0014-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "number1"
  }, [_vm._v("Do not lift the needle off of the surface. Doing so will cause messy and skipped loops. Once the thread is used up, cut it off flush at the back.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("3. If you need to remove stitches, simply pull them out. Be sure to realign the fabric threads by scratching over the surface. Do not reuse the thread — cut this portion off. Outline the design in a darker shade to highlight it, then fill in with various colors and shades. Simply lay rows of punch needle embroidery down side by side. For best results, the rows should follow the contour of the shape being filled.")]), _vm._v(" "), _c('p', {
    staticClass: "number1"
  }, [_vm._v("Like any other technique, punch needle embroidery requires practice, but it does not take long to get the stitches small and even. On my free-form scenes, I complete the piece right up to the embroidery and then punch in the grass and tree leaves through more than one layer of fabric. Adjust the gauges on the punch needle for loops of various depths.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0014-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentbull"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/bull.jpg"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Hoops.")]), _vm._v(" The use of a hoop prevents the stitches from pulling too tightly and the base fabric from wrinkling. A hoop in which your thumb and fingers reach comfortably to the middle seems to be the best (6″ to 7″). Hoops come in metal, plastic, and wood. I find that a wooden hoop with the inner circle wrapped in yarn holds well and is especially useful when stitching velvet or high-napped fabrics.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0014-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _vm._v("Insert the fabric into the hoop by laying the area to be embroidered over the inner ring. Align the fabric so the grain is straight and the surface is smooth. Add the top circle and adjust the tension screw if needed. Always remove your work from the hoop when you are not embroidering so the fabric isn’t marked or creased.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0015-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If odd shapes are problematic, sew the shape onto a large square of support fabric first, basting the shape in place with small running stitches. Insert into the hoop. Working from the wrong side of the fabric, cut away the support fabric from inside the odd shape. The fabric is now ready for embroidery work.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0015-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0012-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentbull"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/bull.jpg"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Frames.")]), _vm._v(" Used for large pieces of embroidery, frames keep the fabric taut and even during stitching. The basic frame consists of two rollers (top and bottom) that have strips of tape or canvas webbing added across the bar length. To support the base fabric, first zigzag stitch a ½″ hem on the edges. Fine base fabrics almost always require support for the edges; try stitching bias tape or attaching strips of support fabric to the edges.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0015-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mark the center of both rollers and the top and bottom edges of the base fabric. Attach the fabric’s edges, using lacing stitches, to the tape or canvas strips on the rollers. Match the center points and work outward from the center. Roll any excess fabric around one roller. The flat side supports hold the rollers in place with pegs or screws. The overall stitching area also depends on the length of the side supports used. Attach the flat side supports, then roll the bars to stretch the fabric.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0016-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Using strong thread, lace the fabric’s edges evenly to the flat side supports. Tighten the lace on each side and knot the thread ends firmly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("An added advantage of working with a frame is that it can be secured on a stand if needed, allowing the needleworker to use both hands while working the stitches.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0016-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0015-04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentbull"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/bull.jpg"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Thimbles.")]), _vm._v(" A thimble is a small metal cap that fits over the middle finger of your stitching hand. The small indentations on the tip hold and guide the needle into place, as well as protect your fingers! It should fit snugly.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0022-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentbull"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/bull.jpg"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Scissors.")]), _vm._v(" Embroidery scissors come in many pleasing shapes and sizes. Make sure they are sharp, strong, and have long, pointed blades for precise cutting when needed. They are used for shearing, cutting threads, and cutting away excess fabric.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0016-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentbull"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/bull.jpg"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Transferring Designs.")]), _vm._v(" Designs for needle-work can be found in magazines, coloring books, and design books — but they must be transferred to the base fabric in order to start.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("1. "), _c('em', [_vm._v("Light Box")]), _vm._v(" — a light box can save many hours. Simply trace your pattern onto tracing paper — making sure the lines are clear and dark. Lay the traced pattern on the light box and place the base fabric over the paper, tracing the outlines with chalk, a light pencil, or a water-erasable pen. A natural light box, of course, is as close as your window.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0016-04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("2. "), _c('em', [_vm._v("Dressmaker’s Carbon Paper")]), _vm._v("—best suited for smooth fabrics. Trace the design on the paper, then lay the paper carbon-side down on the "), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _vm._v("fabric. Redraw the design with a sharp pencil or use a ball-point pen. Be careful not to smudge the fabric.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("3. "), _c('em', [_vm._v("Basting through Tissue Paper")]), _vm._v("—use for high-napped fabrics such as plush, velvets, or wools. Pin the tissue paper (with the outline pattern) onto the fabric. Outline with small running stitches, then tear the paper away. Remove the basting after the embroidery is completed.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0017-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("4. "), _c('em', [_vm._v("Pouncing")]), _vm._v("—an old-fashioned method used for large areas. Best if worked on smooth fabrics. Trace the design onto the tissue paper, then use a needle to make little pin pricks around the design. Pin the tissue paper to the fabric. Dip a powder puff into powdered chalk and shake over the holes. Carefully lift the paper from the fabric; the design can be sprayed with a fixative.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0017-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("5. "), _c('em', [_vm._v("Direct Transfer Method")]), _vm._v("—if using a fine transparent fabric such as lawn, organdy, nylon, or silk, you can directly trace the embroidery design onto the fabric using a pencil or pen made for marking fabrics.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("6. "), _c('em', [_vm._v("Iron-on Transfers")]), _vm._v("—an easy transfer method. Use a hot iron to imprint the design onto your base fabric — remember the design reverses when applied! Always test on sample piece of cloth first; some synthetic fabrics won’t take the transfer.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("7. "), _c('em', [_vm._v("Iron-on Transfer Pencils")]), _vm._v("—first trace the design onto tracing paper using these special pencils. Next, lay the traced design face down on the base fabric, then iron on the fabric (this method of transfer also reverses the design).")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0017-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentbull"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/bull.jpg"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Pens and Pencils.")]), _vm._v(" Always use a light hand when using any pencil or pen!")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("1. "), _c('em', [_vm._v("Water-erasable Pens")]), _vm._v(" — use a very light hand with these pens. As you stitch, make sure that the embroidered stitches cover all the marks. Erase the marks from the fabric back with a wet cloth and cold water.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("2. "), _c('em', [_vm._v("Fade-away Pens")]), _vm._v("—again, use a very light hand and be aware that the marks will fade after 24 hours. These pens work well if you need to finish your project in a hurry.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("3. "), _c('em', [_vm._v("White or Silver Pencils")]), _vm._v("—keep a sharp point on these pencils. I find these very successful for use on dark fabrics.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0018-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentbull"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/bull.jpg"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Enlarging and Reducing Designs.")]), _vm._v(" Patterns are easily reduced or enlarged and help is only as far away as your nearest copy machine. If this is not possible, simply use the grid method. Start by tracing your original design onto paper and enclose it in a rectangle. Place the traced design in the bottom corner of a large sheet of paper. Working from a square corner (point A), draw a diagonal line through the opposite corner of the design to the edge of the paper. Mark the desired height of the new design along the X axis (point X), then extend a horizontal line from point X to the diagonal line (point B). Extend a vertical line from point B to the Y axis (point Y).")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0018-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _vm._v("Divide the original design into squares to form an over all grid. Now mark off the large rectangle with the same number of squares. Draw each design line from the small grid to the large squares.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0019-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0018-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentbull"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/bull.jpg"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Washing the Finished Work.")]), _vm._v(" To wash the embroidered work, use lukewarm water and pure soap flakes. Gently squeeze any excess water from the fabric, then rinse thoroughly. Squeeze again by hand, then leave until partially dry before blocking and pressing.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0019-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentbull"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/bull.jpg"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Blocking and Pressing.")]), _vm._v(" After the finished work is washed, measure a piece of graph paper the same size as the base fabric. Place the fabric right side up on the paper and using the grid lines, pull the fabric into shape. Pin in position with rust-proof push pins. Cover with a damp cloth, or acid-free tissue paper, and leave to dry. If the embroidery is hard to block, or blocking isn’t required, place it right side down on a well-padded board (use toweling for ribbon work) and press lightly using a damp press cloth. Do not flatten the embroidery.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0022-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentbull"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/bull.jpg"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Highlights.")]), _vm._v(" Don’t be afraid to collage different techniques and materials together. Once you’ve finished the embroidery, it may look a bit dull or sparse. Adding beads, tiny buttons, or metal findings may be the "), _c('em', [_vm._v("pièce de résistance")]), _vm._v(" to complete your work. Be sure to keep these highlights in proportion to your work.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _vm._v("1. "), _c('em', [_vm._v("Beads")]), _vm._v("—small seed beads add sparkle and visual beauty to embroidery. Use them to fill in the centers of flowers or to act as individual buds. Use Nymo® beading thread for sewing them in place; this thread will not deteriorate with time or cleaning, and it is virtually invisible within the embroidery.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("2. "), _c('em', [_vm._v("Buttons")]), _vm._v("—keep the size of the button in proportion to the embroidery. Small mother-of-pearl buttons are very pretty with soft pastel work. Antique buttons are better with silk ribbon work on velvets or other plush fabrics.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("3. "), _c('em', [_vm._v("Metal findings")]), _vm._v("—small brass and silver doodads come in a huge variety of shapes and subjects. Perhaps a little bee or a butterfly will add a special highlight to your creation. Birds or flower shapes could also be used. Have fun with these additions.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0019-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentbull"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/bull.jpg"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Useful Tips.")])]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("1. Before working the design, test your threads, yarns, or ribbons for color-fastness. Place these in a glass of water with part of them up and over the edge of the glass. Leave for ten minutes, then remove and lay out on a white paper towel or non-abrasive fabric. Using your fingers, press between the towel, then open and check for color stains.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("2. Always work a small trial piece first to test the thickness of the threads, the stitches, "), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _vm._v("and the appropriateness of the fabric itself.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("3. Always cut more fabric than you will need. The rule of thumb is 2″ extra all around.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("4. Try to avoid knots on the back of your finished work, because they cause bumps and lumps! They also show up as a shiny spots when they have been pressed. Whenever you can, run the starting end through the fabric under the area to be worked, then finish on the wrong side by running the end under the stitches just worked.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("5. If you are constructing clothing that will be embellished, remember to cut the patterns larger than you’ll need to insert the fabric in the hoop or frame. After the seams are sewn up, work some of the embroidery over the seam lines for a more professional look.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("6. Always press your finished work on a padded board. Press from the wrong side with a damp press cloth. If pressing silk ribbon work, use a dry iron and a terry towel for padding.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0020-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentbull"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/bull.jpg"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Storage of Tools and Materials.")]), _vm._v(" There is nothing more frustrating than searching for tools or materials when you are in the middle of a project. I speak from great experience! Here are a few suggestions I’ve gathered from friends for organizing the projects in your workroom or those you take traveling.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("1. Store your ribbons and threads in see-through containers. Whether they are shoe boxes or plastic baggies "), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _vm._v("on metal rings—get your materials out where they are visible and readily available.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("2. Store your current project’s ribbons and threads by color in plastic baggies. Punch a hole in one corner of the bag, then join them with a metal ring or tie them with a ribbon. Write the color code on the bag with a permanent pen.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("3. Keep your needles in separate cases according to their size and use. Store one case in your workroom and keep another with the current project.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("4. Keep a small pair of scissors with your current project(s) at all times.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("5. Pull all the ribbons, threads, fabrics, and tools necessary for a project, then keep them in one container. I use my collection of Chinese sewing baskets for this purpose, but you can certainly use anything from plastic boxes to baskets to cloth carriers.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("6. If you are traveling, a nylon cassette-tape carrier works beautifully as a needlework travel bag. The plastic sections hold ribbon, thread, fabrics, and tools, plus the pocket keeps your project clean and safe. The cases come in many sizes and I found mine at a discount store.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("7. Purchase a small pillowcase or make one of calico (muslin). Store your unfinished projects in these little pillowcases to keep your work clean and neat.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0021-01.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a1ea7246","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9781607053590_07_ch1.vue
// module id = 69
// module chunks = 0